import { useModal, create, show } from "@ebay/nice-modal-react";

import DeleteConfirmationModal from "ds/components/DeleteConfirmationModal";
import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";

import { useUpdateApiKey } from "../../hooks/useUpdateApiKey";
import { ApiKeyView } from "../../types";

type DeleteGroupConfirmationProps = {
  groupName: string;
  apiKey: ApiKeyView;
};

const DeleteGroupConfirmation = create(function DeleteGroupConfirmation({
  groupName,
  apiKey,
}: DeleteGroupConfirmationProps) {
  const modal = useModal();

  const { onUpdate, loading } = useUpdateApiKey({
    apiKeyId: apiKey.id,
    callback: () => {
      modal.resolve();
      modal.hide();
    },
  });

  const handleOnConfirm = () => {
    const updatedTeams = apiKey.teams.filter((team) => team !== groupName);

    onUpdate({
      name: apiKey.name,
      description: apiKey.description,
      teams: updatedTeams,
    });
  };

  return (
    <DeleteConfirmationModal
      isLoading={loading}
      isDismissable={!loading}
      title="Remove group"
      confirmationButtonLabel="Remove"
      onConfirm={handleOnConfirm}
    >
      <ConfirmationModalMessage>
        Are you sure you want to remove the group <strong>{groupName}</strong> from this API key?
        This will revoke the API key's access through this group.
      </ConfirmationModalMessage>
    </DeleteConfirmationModal>
  );
});

export const showDeleteGroupConfirmation = (props: DeleteGroupConfirmationProps) =>
  show(DeleteGroupConfirmation, props);
